module.exports = __webpack_public_path__ + "img/gallery-2.0623cd94.jpg";